"use client";
import * as React from "react";

type Props = {
  enabled?: boolean;
  /** selector ที่ "ยกเว้น" ไม่บล็อกคลิกขวา */
  exceptSelector?: string;
};

export default function DisableContextMenu({
  enabled = true,
  exceptSelector = 'input, textarea, [contenteditable="true"], [data-allow-context]'
}: Props) {
  React.useEffect(() => {
    if (!enabled) return;

    const onContextMenu = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      if (target.closest(exceptSelector)) return; // ยกเว้นบางส่วน
      e.preventDefault();
    };

    // กันคีย์เปิดเมนูบริบท (Shift+F10 / ContextMenu key)
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.shiftKey && e.key === "F10") e.preventDefault();
      if (e.key === "ContextMenu") e.preventDefault();
    };

    window.addEventListener("contextmenu", onContextMenu, { capture: true });
    window.addEventListener("keydown", onKeyDown, { capture: true });
    return () => {
      window.removeEventListener("contextmenu", onContextMenu, { capture: true } as any);
      window.removeEventListener("keydown", onKeyDown, { capture: true } as any);
    };
  }, [enabled, exceptSelector]);

  return null;
}